import getHelper from '../../../services/getHelper';
import type { StudentApplication } from '../../../../../index';

export default getHelper<StudentApplication>('/student-applications/:id', {
  submit: getHelper('/submit/:id'),
  documents: getHelper('/documents/:id'),
  selectRecommendation: getHelper('/select-recommendation/:id'),
  offers: getHelper('/offers/:id'),
  events: getHelper('/events/:id'),
  admit: getHelper('/admit/:id'),
});
